module.exports = __webpack_public_path__ + "img/landing.167433fe.jpg";